import { render, staticRenderFns } from "./detailpositions.vue?vue&type=template&id=7dca0ccd&scoped=true&"
import script from "./detailpositions.vue?vue&type=script&lang=js&"
export * from "./detailpositions.vue?vue&type=script&lang=js&"
import style0 from "./detailpositions.vue?vue&type=style&index=0&id=7dca0ccd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dca0ccd",
  null
  
)

export default component.exports